import {Container, Section, Stack, Text} from 'epic-fortnite-react';
import React from 'react';
import styled from 'styled-components';

const StyledXpBeyond = styled(Section)`
  position: relative;
  z-index: 2;

  @media only screen and (max-width: 768px) {
    padding-bottom: 20rem;
  }
`;

const StyledLogo = styled.img`
  width: 10em;
  margin: 0 auto;
`;

const StyledContentWrapper = styled.div`
  padding: 0 25px;
`;

const SeasonalTextContainer = styled.div`
  padding: 0.5rem;
  @media only screen and (max-width: 1440px) {
    max-width: 900px;
    margin: 0 auto;
  }
`;

const LegalTextContainer = styled.div`
  position: absolute;
  bottom: -60%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  text-transform: 'italic';

  @media only screen and (max-width: 900px) {
    bottom: -70%;
  }

  p {
    text-transform: none !important;
    font-family: OpenSans, sans-serif !important;
    align-self: flex-end;
  }
`;

const XpBeyond = ({data, mobile}) => {
  const {coreSectionProps, heroImage, text, caption, captionLine2} = data;
  const headingSize = mobile ? '3xl' : '6xl';
  const contentSize = mobile ? 'med' : 'xl';
  const bgImg = mobile ? coreSectionProps.mobileBackgroundImage : coreSectionProps.backgroundImage;

  return (
    <StyledXpBeyond
      backgroundImage={bgImg}
      backgroundPosition={
        mobile ? coreSectionProps?.mobileBackgroundPosition : coreSectionProps?.backgroundPosition
      }
      backgroundSize={coreSectionProps?.backgroundSize}
      size="6xl">
      <Container>
        <SeasonalTextContainer>
          <Stack gap="lg" align="center">
            <StyledLogo src={heroImage} />
            <Text
              color={!coreSectionProps.defaultTextColor && !mobile ? '#f5462b' : '#fff'}
              align="center"
              lineLength="med"
              size={!coreSectionProps.defaultTextColor ? '2xl' : headingSize}
              transform="uppercase">
              {text.header}
            </Text>
            <Text
              color="#fff"
              align="center"
              lineLength="med"
              size={!coreSectionProps.defaultTextColor ? 'xl' : headingSize}
              transform="uppercase">
              {text.subtitle}
            </Text>
            <StyledContentWrapper>
              <Text
                color="#FFFFFF"
                lineLength="med"
                size={contentSize}
                transform="uppercase"
                align="center">
                {text.textContent}
              </Text>
            </StyledContentWrapper>
          </Stack>
        </SeasonalTextContainer>
      </Container>
      <LegalTextContainer>
        <Text color="#fff" align="center" size="xs" italic={true}>
          <p>{caption}</p>
          <p>{captionLine2}</p>
        </Text>
      </LegalTextContainer>
    </StyledXpBeyond>
  );
};

export default XpBeyond;
